/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */

'use strict';

function commitLocalUpdate(environment, updater) {
  environment.commitUpdate(updater);
}

module.exports = commitLocalUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/commitLocalUpdate.js
// module id = 2601
// module chunks = 3